import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Container,
  Card,
  Divider,
  Link
} from '@mui/joy';
import { FaCheckCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { IconWrapper } from './IconWrapper';

const WindowOrderSuccess: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Card variant="outlined" sx={{ textAlign: 'center', p: 4 }}>
        <IconWrapper icon={FaCheckCircle} />
        
        <Typography level="h2" sx={{ mb: 2 }}>
          Window Order Submitted
        </Typography>
        
        <Typography level="body-lg" sx={{ mb: 4 }}>
          Thank you for your order. Your window specifications have been submitted
          and will be sent to the supplier.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Box sx={{ maxWidth: 400, mx: 'auto', mb: 4, textAlign: 'left' }}>
          <Typography level="title-md" sx={{ mb: 1 }}>
            What happens next?
          </Typography>
          
          <Typography level="body-md" component="ol" sx={{ pl: 2 }}>
            <li>Your window order details have been received.</li>
            <li>The supplier will review your specifications.</li>
            <li>You may be contacted for additional details or confirmation.</li>
            <li>The supplier will provide a formal quote for your windows.</li>
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Button 
            variant="solid" 
            color="primary" 
            onClick={() => navigate('/')}
          >
            Return to Home
          </Button>
          
          <Button
            variant="outlined"
            color="neutral"
            onClick={() => navigate('/window-designer')}
          >
            Design More Windows
          </Button>
        </Box>
        
        <Typography level="body-sm" sx={{ mt: 4, color: 'text.tertiary' }}>
          If you have any questions, please <Link href="mailto:support@example.com">contact us</Link>.
        </Typography>
      </Card>
    </Container>
  );
};

export default WindowOrderSuccess; 